import { render, staticRenderFns } from "./SwitchColor.vue?vue&type=template&id=fa8185a6"
import script from "./SwitchColor.vue?vue&type=script&lang=ts"
export * from "./SwitchColor.vue?vue&type=script&lang=ts"
function injectStyles (context) {
  
  var style0 = require("./SwitchColor.vue?vue&type=style&index=0&id=fa8185a6&prod&lang=scss")
if (style0.__inject__) style0.__inject__(context)

}

/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  null,
  null
  ,true
)

export default component.exports